"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeUrl = exports.appendRestfulResourceSegmentToUrl = exports.replaceUrlPlaceholders = exports.resolveApiUrl = exports.validateUrlPath = exports.validateBaseURL = void 0;
var logger_1 = require("./logger");
var util_1 = require("./util");
function isFullUrl(url) {
    var FULL_URI_RE = /^(https?:)?(\/\/)/;
    return FULL_URI_RE.test(url);
}
function isFullPath(url) {
    var FULL_PATH_RE = /^\//;
    return FULL_PATH_RE.test(url);
}
function validateBaseURL(baseURL) {
    if (typeof baseURL !== 'string') {
        (0, logger_1.throwError)("baseURL must be string, got ".concat(baseURL));
    }
    if (baseURL.endsWith('/')) {
        (0, logger_1.throwError)('baseURL must not end width /');
    }
}
exports.validateBaseURL = validateBaseURL;
function validateUrlPath(key, apiList) {
    var path = apiList[key];
    if ((0, util_1.isNullOrUndefined)(path)) {
        (0, logger_1.throwError)("apiList\u4E2D\u6CA1\u6709\u5BF9\u5E94\u7684\u952E\u503C".concat(key, "\uFF0C\u67E5\u770B").concat(apiList));
    }
    if (typeof path !== 'string') {
        (0, logger_1.throwError)('apiList中配置的路径必须是字符串');
    }
    if (path[0] !== '/') {
        (0, logger_1.throwError)('apiList中配置的路径必须是以"/"开头');
    }
}
exports.validateUrlPath = validateUrlPath;
/**
 * 解析API指定的url，三种情况
 * 1. 包含协议的完整地址 http://api.example.com/resources 直接返回
 * 2. '/'开头的完整路径 /resources
 * 3. 路径名称 RESOURCES，在配置的apiList中寻找名称RESOURCES对应的路径
 */
function resolveApiUrl(url, context) {
    url = url.trim();
    if (isFullUrl(url) || isFullPath(url)) {
        return url;
    }
    var _a = (context || {}).apiList, apiList = _a === void 0 ? {} : _a;
    validateUrlPath(url, apiList);
    return apiList[url];
}
exports.resolveApiUrl = resolveApiUrl;
function getResourceParamsValue(resourceParams, key) {
    if (resourceParams === void 0) { resourceParams = {}; }
    if ((0, util_1.isMap)(resourceParams)) {
        if (resourceParams.has(key)) {
            return resourceParams.get(key);
        }
    }
    else if (!(0, util_1.isNullOrUndefined)(resourceParams[key])) {
        return resourceParams[key];
    }
}
/**
 * 替换url中:id形式的占位符，id是字母或者下划线开头
 */
function replaceUrlPlaceholders(url, resourceParams) {
    if (resourceParams === void 0) { resourceParams = {}; }
    var PLACEHOLDER_RE = /:([A-Za-z_]\w*)/gi;
    var BRACKET_PLACEHOLDER_RE = /\{([A-Za-z_]\w*)\}/gi;
    var missingPlaceholders = [];
    var replacer = function (_, key) {
        var value = getResourceParamsValue(resourceParams, key);
        if (!(0, util_1.isNullOrUndefined)(value)) {
            return value;
        }
        missingPlaceholders.push(key);
    };
    var replacedUrl = url
        .replace(PLACEHOLDER_RE, replacer)
        .replace(BRACKET_PLACEHOLDER_RE, replacer);
    if (missingPlaceholders.length > 0) {
        (0, logger_1.throwError)("placeholders ".concat(missingPlaceholders.join(','), " found no matched data"));
    }
    return replacedUrl;
}
exports.replaceUrlPlaceholders = replaceUrlPlaceholders;
/**
 * 在url后添加resourceId和resourceAction变量对应的路径，两者都存在时，resourceId在前。
 */
function appendRestfulResourceSegmentToUrl(url, resourceParams) {
    if (resourceParams === void 0) { resourceParams = {}; }
    var result = [url];
    ['resource', 'resourceId', 'resourceAction'].forEach(function (key) {
        var value = getResourceParamsValue(resourceParams, key);
        if ((0, util_1.isNullOrUndefined)(value)) {
            return;
        }
        if (Array.isArray(value)) {
            result.splice.apply(result, __spreadArray([result.length, 0], value, false));
        }
        else {
            result.push(value);
        }
    });
    return result.join('/');
}
exports.appendRestfulResourceSegmentToUrl = appendRestfulResourceSegmentToUrl;
function makeUrl(url, context) {
    var fullUrl = resolveApiUrl(url, context);
    fullUrl = replaceUrlPlaceholders(fullUrl, context.resourceParams);
    fullUrl = appendRestfulResourceSegmentToUrl(fullUrl, context.resourceParams);
    return encodeURI(fullUrl);
}
exports.makeUrl = makeUrl;
